import lessonFilterTypes from 'helpers/enums/filters/lessonFilterTypes'
import { localize } from 'helpers/translator'

const getLessonTypeText = type => {
	switch (type) {
		case lessonFilterTypes.REGULAR:
			return localize('store_search_filter_lessons')
		case lessonFilterTypes.VIDEO:
			return localize('store_search_filter_videos')
		case lessonFilterTypes.STANDALONE_ACTIVITIES:
			return localize('store_search_filter_activities')
	}

	return ''
}

export {
	getLessonTypeText,
}
